var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-data"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"calendar-data__inputs"},[_c('span',{class:{
        'calendar-data__input': true,
        'calendar-data__input--focus': _vm.selectionMode === 'start',
      }},[_vm._v("\n      "+_vm._s(_vm.selected.start == 0 ? 'Od' : _vm.selected.start.format('dd DD.MM'))+"\n    ")]),_vm._v(" "),_c('span',{class:{
        'calendar-data__text': true,
        'calendar-data__text--focus': _vm.selectionMode === 'end',
      }},[_vm._v("\n      -\n    ")]),_vm._v(" "),_c('span',{class:{
        'calendar-data__input': true,
        'calendar-data__input--focus': _vm.selectionMode === 'end',
      }},[_vm._v("\n      "+_vm._s(_vm.selected.end == 0 ? 'do' : _vm.selected.end.format('dd DD.MM'))+"\n    ")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-data__label"},[_c('span',[_vm._v("Wylot od - do")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c30fe05","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/MobileDataDisplay.vue
// module id = 623
// module chunks = 1